import { Injectable } from '@angular/core';
// import { Paso5Component} from './paso5/paso5.component'
import * as firebase from 'firebase'


@Injectable({
  providedIn: 'root'
})
export class GranServicioDePTWService {

  idSolicitud;
  objetoCompletoDeSolicitud
  pasoActivo='1'
  arrayDeEmpleados=[]
  solicitudEsNueva = true
  objetoPasosCompletados={paso1:'',paso2:'',paso3:'',paso4:'',paso5:'',paso6:'',paso7:'',paso8:''}

  valoresParaQuery={fechaquerymin:'',fechaquerymax:'',unidadDeNegocio:'',cuenca:''}

  constructor() { }


  cargadatosdePTW( callback){
    let query = firebase.firestore().collection("ptws").doc(this.idSolicitud)
    query.get().then((doc)=>{
      callback(doc)
    }).catch((err)=>{
      console.log(err);
    })
  }


  


}
